import { useSubject } from '@lib/common/hooks/use-subject';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { AppBar, Typography, Button, Divider } from '@material-ui/core';
import { deepPurple, green, grey, blue, indigo, teal, purple } from '@material-ui/core/colors';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import { sample } from 'lodash';
import { useState } from 'react';
import { debounceTime, map } from 'rxjs/operators';

type MuiColor = { [k in keyof typeof deepPurple]?: string };
interface Color extends MuiColor {}

const colors: Color[] = [deepPurple, teal, purple, green, grey, blue, indigo];

export const Footer = () => {
  const hoverIn$ = useSubject();
  const [color, setColor] = useState(() => sample(colors));

  useSubscription(() =>
    hoverIn$
      .pipe(
        debounceTime(200),
        map(() => sample(colors))
      )
      .subscribe(setColor)
  );

  return (
    <AppBar
      component="div"
      onMouseEnter={hoverIn$.next}
      onMouseLeave={hoverIn$.next}
      style={{ background: color[800], transition: 'all .3s ease-in' }}
      position="relative">
      {footerElement}
    </AppBar>
  );
};
const footerElement = (
  <>
    <div
      style={{
        display: 'flex',
        padding: 30,
        gap: 20,
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <div>
        <Typography variant="h3">Vitrina DELI</Typography>
        <Typography variant="body2">
          🥪 <strong>D</strong>omain <strong>E</strong>xpert in the <strong>L</strong>oop{' '}
          <strong>I</strong>nterface
        </Typography>
        <Divider style={{ backgroundColor: 'white' }} />
        <Typography variant="caption">
          Copyright © <strong>Vitrina</strong> {new Date().getFullYear()}, or its affiliates. All
          rights reserved.
        </Typography>
      </div>
      <div>
        <Typography variant="body2">
          Have some feedback😀?
          <br />
          Want to request features🌟?
          <br />
          Want to report errors⚠️?
        </Typography>
        <br />
        <Button
          size="small"
          component="a"
          href="mailto:paromita@vitrina.ai,deli_vitrina@persistent.com?subject=DELI feedback&body=I want to give feedback, report error, request a feature for DELI"
          startIcon={<AlternateEmailIcon />}
          variant="outlined"
          style={{ color: 'white', borderColor: 'white' }}>
          Let us know! 📧
        </Button>
      </div>
    </div>
  </>
);
